import { Navigate } from "react-router-dom";

const ProtectedRoute = ({ children }) => {
  // Allow bypassing authentication if infraDev is set
  const disableAuth = !!window.APP_CONFIG?.infraDev;

  if (disableAuth) {
    return children;
  }

  const isLoggedIn = localStorage.getItem("__ac_user");

  if (!isLoggedIn) {
    return <Navigate to="/login" replace />;
  }

  return children;
};

export default ProtectedRoute;
